<template>
  <div class="oldmagazine">
    <div class="oldmagazine-title"
         :class="language==='en'?'en':'cn'"></div>
    <div class="oldmagazine-box">
      <ul v-bind:style="styles">
        <li v-for="item in list"
            @click="openUrl(item.link)"
            :key="item.id">
          {{item.date}}
        </li>
      </ul>
    </div>
    <div class="oldmagazine-bottom row">
      <div class="btn left"
           @click="moveDown" :class="{ active: isFirst }"></div>
      <div class="btn right"
           @click="moveUp" :class="{ active: isLast }"></div>
    </div>
  </div>
</template>
<script>
import { getOldMagazine } from '@/api';
import store from '@/store';

export default {
  name: 'oldmagazin',
  mounted() {
    getOldMagazine(store.state.code).then((res) => {
      this.list = res;
    });
  },
  data() {
    return {
      language: 'zh',
      list: [],
      position: 0,
      styles: {
        transform: `translateY(-${this.position}px)`,
      },
    };
  },
  computed: {
    isLast() {
      return (this.list.length - this.position > 3);
    },
    isFirst() {
      return !(this.position < 1);
    },
  },
  methods: {
    openUrl(url) {
      const _url = url.replace('mulubao_html.php', 'dist/#/');
      window.open(_url);
    },
    moveUp() {
      if (this.list.length - 3 > this.position) {
        this.position += 1;
        const str = `translateY(-${this.position * 26}px)`;
        this.styles.transform = str;
      }
    },
    moveDown() {
      if (this.position > 0) {
        this.position -= 1;
        const str = `translateY(-${this.position * 26}px)`;
        this.styles.transform = str;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.oldmagazine {
  width: 80px;
  height: 130px;
  position: relative;
  margin-top: 20px;
  &-title {
    height: 25px;
    width: 100%;
    background-image: url("~@/assets/icon/cn/imgMagazine.png");
    background-repeat: no-repeat;
    background-position: center;
    background-color: #0000008c;
  }
  &-title.en {
    background-image: url("~@/assets/icon/en/imgMagazine.png");
  }
  &-box {
    height: 78px;
    width: 100%;
    margin: 0px;
    padding: 0px;
    overflow: hidden;
    ul {
      width: 100%;
      margin: 0px;
      padding: 0px;
      transition: all 0.5s;
      li {
        font-size: 10px;
        line-height: 25px;
        margin-top: 1px;
        color: #9c9c9c;
        background-color: #000000ad;
        cursor: pointer;
      }
      li:hover {
        background-color: #9d9ea2;
        color: white;
      }
    }
  }
  &-bottom {
    margin-top: 1px;
    height: 25px;
    background-color: #000000ad;
    .btn {
      flex: 1;
      background-repeat: no-repeat;
      background-position: center;
      height: 100%;
      cursor: pointer;
    }
    .left {
      background-image: url("~@/assets/icon/prevHDisabled.png");
    }
    .right {
      background-image: url("~@/assets/icon/nextHDisabled.png");
    }
    .left.active{
       background-image: url("~@/assets/icon/prevH.png");
    }
    .right.active {
      background-image: url("~@/assets/icon/nextH.png");
    }
  }
}
</style>
